import { CapitalizedFormatter } from './formatter/capitalized'
import { AllNormalizer } from './normalizer/all'
import { CamelCaseNormalizer } from './normalizer/camelCase'
import { EnumNormalizer } from './normalizer/enum'
import { UppercaseNormalizer } from './normalizer/uppercase'
import { WhitespaceNormalizer } from './normalizer/whitespace'

export interface Normalizer {
  matches: (input: string) => boolean
  normalize: (input: string) => string[]
}

export interface Formatter {
  format: (parts: string[]) => string
}

export class StringFormatter {
  static normalizers = {
    enum: EnumNormalizer,
    camelCase: CamelCaseNormalizer,
    whitespace: WhitespaceNormalizer,
    all: AllNormalizer,
    uppercase: UppercaseNormalizer,
  }

  static formats = {
    capitalized: CapitalizedFormatter,
  }

  constructor(private config: { normalizers: Normalizer[]; format: Formatter }) {}

  format(input: string) {
    const normalizer = this.config.normalizers.find((normalizer) => normalizer.matches(input))

    if (!normalizer) {
      console.warn(`No normalizer found for input: ${input}`)
      return input
    }

    return this.config.format.format(normalizer.normalize(input))
  }
}
